import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap5';

import routes from 'app/routes';
import { useContext } from 'components/Managers/Dashboard/Context';
import useApiData from 'components/Managers/Dashboard/Hooks/useApiData';
import StatisticButton from './StatisticButton';
import StatisticModal from './StatisticModal';

export default function AssessmentsStatistic({ value }) {
  const [showModal, setShowModal] = useState(false);
  const route = routes.api.managers.dashboard.assessments_completed;
  const { state: { filters } } = useContext();
  const { data: assessments, loading: assessmentsLoading } = useApiData(showModal && route, filters);

  const columns = [
    {
      name: 'First Name',
      selector: (row) => row.first_name,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Last Name',
      selector: (row) => row.last_name,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Program',
      selector: (row) => row.title,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Type',
      selector: (row) => row.type,
    },
  ];

  return (
    <Col md="4" className="mb-2 mb-md-0">
      <StatisticButton
        label="Assessments"
        value={value}
        onClick={() => setShowModal(true)}
        className="bg-primary-100"
      />

      <StatisticModal
        show={showModal}
        title="Talent Assessments"
        columns={columns}
        data={assessmentsLoading ? null : assessments}
        onCloseClick={() => setShowModal(false)}
      />
    </Col>
  );
}

AssessmentsStatistic.propTypes = {
  value: PropTypes.number,
};

AssessmentsStatistic.defaultProps = {
  value: null,
};
